export default __webpack_public_path__ + "static/media/marker.9423bfde.svg";